module.exports = __webpack_public_path__ + "img/collect_icon_bg.ef62ba54.png";